import {Component, AfterViewChecked, inject} from '@angular/core';
import {ShepherdService} from 'angular-shepherd';
import {TourOptions} from 'shepherd.js';
import {CdkSidebarService} from '@cdk/components/sidebar/sidebar.service';

@Component({
    selector: 'shepherd',
    templateUrl: './tour.component.html',
    styleUrls: ['./tour.component.scss']
})
export class ShepherdComponent implements AfterViewChecked {
    shepherdService = inject(ShepherdService);
    _cdkSidebarService = inject(CdkSidebarService);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);


    constructor() {
    }

    tourInicio: boolean;

    ngAfterViewChecked() {
        if (this.shepherdService.isActive === false) {
            this._cdkSidebarService.getSidebar('navbar').toggleFold();
            this.tourInicio = false;
            this.shepherdService.isActive = true;
        }
    }
}
